<template>
  <div class="contract-information-page pb60" v-loading.fullscreen.lock="fullscreenLoading">
    <Title currentPageTitle="预开票审批申请"></Title>
    <!-- 开票说明 -->
    <div class="contract-base-box">
      <p class="contract-base-name">开票说明</p>
      <el-row :gutter="24">
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>开票金额（元）：</div>
          <el-input
            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
            maxlength="12"
            @blur="formData.invoiceAmount = $event.target.value"
            v-model.trim="formData.invoiceAmount"
            class="contract-base-content"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
   
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>开票主体：</div>
          <el-select
            disabled
            filterable
            v-model="formData.servicerTenantGuid"
            @change="servicerTenantChange"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option v-for="item in serviceTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>发票类型：</div>
          <el-select v-model="formData.invoiceOptions" class="contract-base-content" placeholder="请选择">
            <el-option
              v-for="item in getCodeListByKey('发票选项')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>药企名称：</div>
          <el-select
            filterable
            v-model="formData.tenantGuid"
            @change="tenantChange"
            class="contract-base-content"
            placeholder="请选择"
            @focus="tenantFocus(1)"
          >
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>组织名称：</div>
          <el-select
            filterable
            v-model="formData.organisationGuid"
            @change="organisationChange"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option v-for="item in organisationList" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>月份：</div>
          <el-date-picker
            class="contract-base-content"
            v-model="formData.month"
            type="month"
            value-format="yyyy-MM"
            placeholder="请选择"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>开票日期：</div>
          <el-date-picker
            class="contract-base-content"
            v-model="formData.invoiceDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择"
          >
          </el-date-picker>
        </el-col>

        <!-- 是否盖章 新增字段 -->
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否盖章：</div>
          <el-select @change="formData.stampType=null;formData.useStampWay=null" v-model="formData.isStamp" class="contract-base-content" placeholder="请选择">
            <el-option
              v-for="item in trueOrFalseOption"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <!-- 印章类型 新增字段 -->
        <el-col :span="12" v-if="formData.isStamp=='Y'">
          <div class="contract-base-title"><span class="fontC-red">*</span>印章类型：</div>
          <el-select v-model="formData.stampType" class="contract-base-content" placeholder="请选择">
            <el-option
              v-for="item in stampTypeOption"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
           <!-- 用章方式 新增字段 -->
        <el-col :span="12" v-if="formData.isStamp=='Y'">
          <div class="contract-base-title"><span class="fontC-red">*</span>用章方式：</div>
          <el-select v-model="formData.useStampWay" class="contract-base-content" placeholder="请选择">
            <el-option
              v-for="item in useStampWayOption"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否回款：</div>
          <el-select
            @change="formData.receivePaymentGuidList = []"
            v-model="formData.isReceivePayment"
            class="contract-base-content"
            placeholder="请选择"
          >
            <el-option v-for="item in trueOrFalseOption" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <!-- class="sum-row" -->
        <el-col :span="12" v-if="formData.isReceivePayment == 'Y'" >
          <!-- <div class="sum-div"> -->
            <div class="contract-base-title"><span class="fontC-red">*</span>关联收款：</div>
            <el-select
              multiple
              filterable
              v-model="formData.receivePaymentGuidList"
              class="contract-base-content"
              placeholder="请选择"
            >
              <el-option v-for="item in isApplyInvoiceTableData" :key="item.guid" :label="item.label" :value="item.guid">
              </el-option>
            </el-select>
          <!-- </div> -->
          <!-- <div class="sum-div">
            <div class="contract-base-title"><span class="fontC-red"></span>小计：</div>
            <span class="contract-base-content">{{ getSumAmount(formData.receivePaymentGuidList)| numDigit }} 元</span>
          </div> -->
        </el-col>
        <el-col :span="12" v-if="formData.isReceivePayment == 'N'">
          <div class="contract-base-title"><span class="fontC-red">*</span>预计回款日期：</div>
          <el-date-picker
            class="contract-base-content"
            v-model="formData.planRepayDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否邮寄：</div>
          <el-select @change="formData.mailAddress=null;" v-model="formData.isMail" class="contract-base-content" placeholder="请选择">
            <el-option
              v-for="item in trueOrFalseOption"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12" v-if="formData.isReceivePayment == 'Y'">
          <div class="contract-base-title"><span class="fontC-red"></span>小计：</div>
          <div  class="contract-base-content">{{ getSumAmount(formData.receivePaymentGuidList)| numDigit }} 元</div>
          
        </el-col>
        <!-- 邮寄地址 新增字段 -->
        <el-col :span="24" v-if="formData.isMail=='Y'">
          <div class="contract-base-title"><span class="fontC-red">*</span>邮寄地址：</div>
          <el-input
            v-model.trim="formData.mailAddress"
            class="contract-base-content"
            placeholder="请输入"
            clearable
            maxlength="50"
            :rows="3"
            type="textarea"
            resize="none"
            style="width:100%;max-width: calc(50% + 324px)!important;"
 
          ></el-input>
        </el-col>
    

        <el-col :span="24">
          <div class="contract-base-title"><span class="fontC-red"> </span>简述或备注：</div>
          <el-input
            v-model.trim="formData.remarks"
            class="contract-base-content"
            placeholder="请输入"
            clearable
            maxlength="200"
            :rows="3"
            type="textarea"
            resize="none"
            style="width:100%;max-width: calc(50% + 324px)!important;"
 
          ></el-input>
        </el-col>
     
        <el-col :span="24"  v-if="formData.isStamp=='Y'">
          <div class="contract-base-title"><span class="fontC-red"> </span>原件上传：</div>
          <div>
            <el-upload
              class="upload-demo t-left"
              action="#"
              multiple
              accept=".pdf,.docx,.doc"
              :on-remove="handleFileRemoveOther"
              :http-request="uploadFileOther"
              :file-list="otherFile"
              :beforeUpload="beforeAvatarUploadOther"
            >
            <div class="import-btn-tips">
                <el-button size="mini" icon="el-icon-my-import"  type="importNew">导入文件</el-button>
                <div class="import-step-tip">支持.pdf,.docx,.doc文件，单个文件不得大于{{ fileSizeTip }}M</div>
            </div>
            </el-upload>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 开票信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">开票信息</p>
      <el-row :gutter="24" class="mb20">
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>发票抬头：</div>
          <el-input
            disabled
            v-model.trim="formData.invoiceTenantName"
            class="contract-base-content"
            :maxlength="30"
            placeholder="不可修改，请选择开户银行"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>合计金额(元)：</div>
          <el-input
            disabled
            v-model.trim="formData.invoiceAmount"
            class="contract-base-content"
            :maxlength="30"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
            <!-- 发票类目 start -->
        <div class="invoice-category" v-for="(item, index) in formData.invoiceApplyDetailList" :key="index">
          <el-col :span="12">
            <div class="contract-base-title"><span class="fontC-red">*</span>发票类目{{index+1}}：</div>
            <el-select v-model="item.invoiceCategory" class="contract-base-content" placeholder="请选择">
              <el-option
                v-for="item in getCodeListByKey('发票类目')"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12">
            <div class="contract-base-title"><span class="fontC-red">*</span>金额(元)：</div>
            <el-input
              v-model.trim="item.invoiceAmount"
              class="contract-base-content"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
              maxlength="12"
              placeholder="请输入"
              clearable
            ></el-input>
            <div class="invoice-category-btns">
              <div class="add"  @click="addInvoiceCategory">添加类目</div>
              <div class="del" v-if="index!=0" @click="delInvoiceCategory(index)">删除</div>
            </div>
          </el-col>
        </div>
        <!--发票类目 end  -->
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>开户银行：</div>
          <el-select
            filterable
            v-model="formData.contractBankGuid"
            @change="bankChange"
            class="contract-base-content"
            placeholder="请选择"
            @focus="tenantFocus(2)"
          >
            <el-option v-for="item in bankList" :key="item.guid" :label="item.bankName" :value="item.guid"> 
              <span style="float: left">{{ `${item.bankName}_${item.bankAccount}_${$getNameByKey(item.accountType,'账户类型')}` }}</span>
            </el-option>

          </el-select>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red"> </span>税号：</div>
          <el-input
            disabled
            v-model.trim="formData.taxpayerId"
            class="contract-base-content"
            oninput="if(/[\u4e00-\u9fa5/\s+/]|[^a-zA-Z0-9\u4E00-\u9FA5]/.test(value)) value=value.replace(/\D/g,'')"
            :maxlength="20"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
    
    
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red"> </span>银行账号：</div>
          <el-input
            disabled
            v-model.trim="formData.bankAccount"
            class="contract-base-content"
            :maxlength="15"
            oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'')"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red"> </span>电话号码：</div>
          <el-input
            v-model.trim="formData.contactTel"
            @input="form.contactsMobile = form.contactsMobile.replace(/[^\d\-\d]/g, '')"
            class="contract-base-content"
            :maxlength="20"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-col>

        <el-col :span="24">
          <div class="contract-base-title"><span class="fontC-red"> </span>单位地址：</div>
          <el-input
            v-model.trim="formData.address"
            class="contract-base-content"
            :maxlength="50"
            placeholder="请输入"
            clearable
            type="textarea"
            resize="none"
            style="width:100%;max-width: calc(50% + 324px)!important;"
          ></el-input>
        </el-col>
      </el-row>
    </div>
    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>
    <!-- 提交 -->
    <div class="submit_btn_wrap">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button type="borderGreen" size="small" @click="saveReq(0)" v-if="$route.query.toType !== '3'">保存</el-button>
      <el-button type="importNew" size="small" @click="saveReq(1)">提交申请</el-button>
    </div>
  </div>
</template>
<script>
import { route } from '@/api/apiRoute';
import { bpmnroute } from '@/api/apiRoute';
import store from '@/store';
import Title from '@/components/title/title.vue';
import Decimal from "decimal"
export default {
  components: {
    Title,
  },
  data() {
    return {
      fileSizeTip: '20',
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      flowType: '00019',
      fullscreenLoading: false,
      tenantList: [], //药企
      serviceTenantList: [], //服务商
      organisationList: [], //组织
      bankList: [],
      otherFile:[],
      // 表单内容
      formData: {
        otherFile:[],
        guid: null,
        invoiceTenantName:null,//发票抬头
        invoiceAmount: null,//开票金额
        servicerTenantGuid: null,//服务商唯一标识，开票主体
        servicerTenantName: null,//服务商名称
        invoiceOptions: null,//发票类型
        tenantGuid: null,//药企唯一标识
        tenantName: null,//药企名称
        organisationGuid: null,//组织唯一标识
        organisationName: null,//组织名称
        month: null,//月份
        // invoiceCategory: null,//发票类目
        planRepayDate: null,//预计回款日期
        remarks: null,//简述或备注
        taxpayerId: null,//税号
        contactTel: null,//电话号码
        contractBankGuid: null,//合同开户行唯一标识
        bankName: null,//开户银行
        bankAccount: null,//银行账号
        address: null,//单位地址
        bizApproveState: null,//业务审批状态(N 草稿中 ；A 审批中 ；Y 已通过 ；R 驳回 ；C 已撤销 ；D 已废弃 ；
        currentTenantGuid: null,//当前登录人的公司唯一标识
        isSendFlowFlag: null,//是否发起流程(Y 是 ；N 否 ； 默认为N或者空)
        isMail:null,//是否邮寄，Y 是；N 否
        mailAddress:null,	//邮寄地址
        isStamp:null,// 是否盖章【取数据字典：是否，N 否；Y 是】
        stampType	:null,// 印章类型【取数据字典：印章类型，1 业务章；2 公章】
        useStampWay:null,	//用章方式
        isReceivePayment: null, //是否回款，Y 是；N 否
        receivePaymentGuidList: [], //关联收款
        invoiceDate:null,//开票日期,
        invoiceApplyDetailList:[{invoiceCategory:null,invoiceAmount:null}],//发票类目
      },
      isApplyInvoiceTableData: [],
      //流程
      srcs: '',//bpmn地址
      processInstanceId: '',//流程id
      iframeSh: false,//流程显示
      trueOrFalseOption: [{ text: '是', value: 'Y' }, { text: '否', value: 'N' }],
      stampTypeOption: [{ text: '业务章', value: '1' }, { text: '公章', value: '2' }],
      useStampWayOption: [{ text: '鲜章', value: '1' }, { text: '电子章', value: '2' }]
    };
  },
  created() {
    this.formData.servicerTenantGuid = localStorage.guid;
    this.getFlowGuid();
    this.getServiceTenantList();
    if (this.$route.query.guid) {
      this.getPageDetail();
    } 
  },
  methods: {
    getSumAmount(list, type) {
      let sum = 0;
      
     console.log('pp',list);
     
        list.forEach((item) => {
          this.isApplyInvoiceTableData.filter(j=>{
            if(item==j.guid){
              sum += Math.round(j.receiveAmount * 100) / 100 ;
            }
          })
          
        });
     
      
      return sum;
    },
    //新增发票类目
    addInvoiceCategory(){
      this.formData.invoiceApplyDetailList.push({
        invoiceCategory:null,
        invoiceAmount:null
      })
    },
     //删除发票类目
    delInvoiceCategory(index){
      this.formData.invoiceApplyDetailList.splice(index,1)
    },
    //获取服务商
    getServiceTenantList() {
      let self = this;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/select-service-tenants`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.serviceTenantList = res.data.data || [];
          self.getTenantList();
          // self.servicerTenantChange(self.formData.servicerTenantGuid);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //服务商变化清空药企重新请求
    servicerTenantChange(val) {
      if (val) {
        this.formData.tenantName = null;
        this.formData.tenantGuid = null;
        this.getTenantList(val);
      }
    },
    //获取药企
    getTenantList(val) {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // getTenantList(val){
    //   let self = this;
    //   self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/select-send-tenants?serviceTenantGuid=${val}`).then((res) => {
    //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //       self.tenantList = res.data.data || [];
    //     } else {
    //       self.$message.error(res.data.msg);
    //     }
    //   });
    // },
    //药企变化清空银行值
    tenantChange(val) {
      if (val) {
        this.tenantList.forEach((i) => {
          if (i.sendTenantGuid == val) {
            this.formData.tenantName = i.sendTenantName;
          }
        });
        this.getOrganisationList(val);
        this.getBankList(val);
        this.getInvoiceItem();
        this.formData.organisationName = null;
        this.formData.organisationGuid = null;
        this.formData.bankName = null;
        this.formData.contractBankGuid = null;
        this.formData.bankAccount = null;
        this.formData.taxpayerId = null;
        this.formData.address = null;
        this.formData.contactTel = null;
      }
    },
    //药企选择判断
    tenantFocus(type) {
      if (!this.formData.servicerTenantGuid) {
        this.$message.error('请先选择开票主体');
      }
      if (type == 2 && !this.formData.tenantGuid) {
        this.$message.error('请先选择药企');
      }
    },
    //获取组织
    getOrganisationList(v) {
      let self = this;
      self.api
        .get(`/${serverConfig.msPersonnelService}/organisation/get-organisation-dict?tenantGuid=${v}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.organisationList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //组织变化赋值
    organisationChange(val) {
      if (val) {
        this.organisationList.forEach((i) => {
          if (i.value == val) {
            this.formData.organisationName = i.text;
          }
        });
      }
    },
    //获取开户银行
    getBankList(val) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/tenant/get-tenant-invoice-list?tenantGuid=${val}&bizState=Y`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.bankList = res.data.data || [];
            // self.bankList.forEach(item => {
            //   item.bankNameLabel = item.bankName + ' _ ' + item.bankAccount + ' _ ' + this.getName(item.accountType, '账户类型');
            // })
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getName(name, key) {
      if (!name) return '-';
      let list = this.getCodeListByKey(key);
      if (typeof name == 'object') {
        let newArr = [];
        name.forEach(item => {
          list.forEach(el => {
            if (el.value == item) {
              newArr.push(el.text);
            }
          })
        })
        return newArr.length ? newArr.join('、') : '-';

      } else {
        let lisArr = list.filter(item => item.value == name);
        return lisArr.length ? lisArr[0].text : '-';
      }
    },
    // 银行选择赋值
    bankChange(val) {
      if (val) {
        this.bankList.forEach((i) => {
          if (i.guid == val) {
            this.formData.bankName = i.bankName;
            this.formData.bankAccount = i.bankAccount;
            this.formData.taxpayerId = i.taxpayerId;
            this.formData.address = i.address;
            this.formData.contactTel = i.tel;
            this.formData.invoiceTenantName = i.tenantName;
          }
        });
      }
    },
    //获取上游数据
    getInvoiceItem(val) {
      let self = this;
      let query = {
        streamType: '1',
        payTenantGuid: self.formData.tenantGuid,
        receiveTenantGuid: localStorage.guid,
        isQueryChild:"Y"
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/get-select-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.isApplyInvoiceTableData = res.data.data || [];
          if (self.isApplyInvoiceTableData.length > 0) {
            self.isApplyInvoiceTableData.forEach((i) => {
              i.label =
                self.$moment(i.receiveDate).format('YYYY-MM-DD') +
                '收款' +
                this.formatMoney(i.receiveAmount || 0) +
                '元';
            });
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取详情
    getPageDetail() {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msSalesPerformService}/upstream/payment-plan-invoice-apply/detail?guid=${this.$route.query.guid}`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = res.data.data;
            this.getFormData(2, data);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //页面信息
    getFormData(type, data) {
      this.formData = {
        guid: type == 1 ? null : data.guid,
        invoiceAmount: data.invoiceAmount.toFixed(2),
        servicerTenantGuid: data.servicerTenantGuid,
        servicerTenantName: data.servicerTenantName,
        invoiceOptions: data.invoiceOptions,
        tenantGuid: data.tenantGuid,
        tenantName: data.tenantName,
        organisationGuid: data.organisationGuid,
        organisationName: data.organisationName,
        month: data.month?data.month.substr(0, 4) + '-' + data.month.substr(4, 2):null,
        invoiceApplyDetailList: data.invoiceApplyDetailList||[{invoiceCategory:null,invoiceAmount:null}],
        planRepayDate: data.planRepayDate?this.$moment(data.planRepayDate).format('YYYY-MM-DD'):null,
        remarks: data.remarks,
        taxpayerId: data.taxpayerId,
        contactTel: data.contactTel,
        contractBankGuid: data.contractBankGuid,
        bankName: data.bankName,
        bankAccount: data.bankAccount,
        address: data.address,
        bizApproveState: data.bizApproveState,
        currentTenantGuid: data.currentTenantGuid,
        isSendFlowFlag: data.isSendFlowFlag,
        isMail: data.isMail,
        invoiceDate: data.invoiceDate,
        mailAddress: data.mailAddress,	//邮寄地址
        isStamp: data.isStamp,// 是否盖章【取数据字典：是否，N 否；Y 是】
        stampType: data.stampType,// 印章类型【取数据字典：印章类型，1 业务章；2 公章】
        useStampWay: data.useStampWay,	//用章方式
        invoiceTenantName: data.invoiceTenantName, //发票抬头
        isReceivePayment: data.isReceivePayment,//是否回款，Y 是；N 否
        receivePaymentGuidList: data.receivePaymentGuidList || [], //关联收款
      };
       console.log(this.formData )
      this.formData.otherFile = [];
      if (data.otherFile && data.otherFile.length) {
        // console.log(data.otherFile )
        // return;
        data.otherFile.forEach(item => {
          this.otherFile.push({
            name: item.fileName,
            path: item.path
          })
        })
        this.$forceUpdate();
      }
   
      this.getTenantList(data.servicerTenantGuid);
      this.getOrganisationList(data.tenantGuid);
      this.getBankList(data.tenantGuid);
      this.getInvoiceItem();
    },
    // 补零
    formatToTwoDecimals(amount) {
      // 如果是 Decimal 对象，先转换为数值
      if (typeof amount === 'object' && amount.toNumber) {
        amount = amount.toNumber();
      }
      // 转换为数值并固定2位小数
      const num = parseFloat(amount);
      return num.toFixed(2);
    },
    // 页面校验
    checkForm() {
      if (!this.formData.invoiceAmount) {
        this.$message.error('开票金额不能为空');
        return false;
      }
      if (!this.formData.servicerTenantGuid) {
        this.$message.error('开票主体不能为空');
        return false;
      }
      if (!this.formData.invoiceOptions) {
        this.$message.error('发票类型不能为空');
        return false;
      }
      if (!this.formData.tenantGuid) {
        this.$message.error('药企名称不能为空');
        return false;
      }
      if (!this.formData.organisationGuid) {
        this.$message.error('组织名称不能为空');
        return false;
      }
      if (!this.formData.month) {
        this.$message.error('月份不能为空');
        return false;
      }
      if (!this.formData.invoiceDate) {
        this.$message.error('开票日期不能为空');
        return false;
      }
   
      if (!this.formData.isStamp) {
        this.$message.error('是否盖章不能为空');
        return false;
      }
      if (this.formData.isStamp == 'Y' && !this.formData.stampType) {
        this.$message.error('印章类型不能为空');
        return false;
      }
      if (this.formData.isStamp == 'Y' && !this.formData.useStampWay) {
        this.$message.error('用章方式不能为空');
        return false;
      }
      if (!this.formData.isReceivePayment) {
        this.$message.error('是否回款不能为空');
        return false;
      }
      if (this.formData.isReceivePayment == 'Y' && !this.formData.receivePaymentGuidList.length) {
        this.$message.error('关联收款不能为空');
        return false;
      }
      if (this.formData.isReceivePayment == 'N' &&!this.formData.planRepayDate) {
        this.$message.error('预计回款日期不能为空');
        return false;
      }
      if (!this.formData.isMail) {
        this.$message.error('是否邮寄不能为空');
        return false;
      }
      if (this.formData.isMail == 'Y' && !this.formData.mailAddress) {
        this.$message.error('邮寄地址不能为空');
        return false;
      }
      if (!this.formData.invoiceTenantName) {
        this.$message.error('发票抬头不能为空');
        return false;
      }
      try {
        this.formData.invoiceApplyDetailList.forEach((item, index) => {
          if (!item.invoiceCategory) {
            throw new Error(`发票类目${index + 1}不能为空`)
          }
          if (!item.invoiceAmount) {
            throw new Error('金额不能为空')
          }
        })
      } catch (error) {
        this.$message.error(error.message);
        return false
      }
      if (!this.formData.bankName) {
        this.$message.error('开户银行不能为空');
        return false;
      }
      let invoiceAmount = 0;
      this.formData.invoiceApplyDetailList.forEach(item => {
        invoiceAmount = Decimal(invoiceAmount).add(item.invoiceAmount);
      })
      // 将累加结果格式化为2位小数
      const formattedSum = this.formatToTwoDecimals(invoiceAmount);
      // 将总金额也格式化为2位小数
      const formattedTotal = this.formatToTwoDecimals(this.formData.invoiceAmount);
      if (formattedSum !== formattedTotal) {
        this.$message.error('发票类目金额之和与合计金额必须相等');
        return false;
      }
      return true;
    },
    //提交申请 type为1时保存否则提交
    saveReq(type) {
      if (type == 1 && !this.checkForm()) {
        return;
      } else if (!this.formData.servicerTenantGuid) {
        this.$message.error('开票主体不能为空');
        return false;
      }
      let userinfo = JSON.parse(localStorage.userInfo);
      let form = JSON.parse(JSON.stringify(this.formData));
      let reqUrl;
      form.staffGuid = userinfo.staffGuid;
      form.staffName = userinfo.staffName;
      this.serviceTenantList.forEach((i) => {
        if (i.guid == form.servicerTenantGuid) {
          form.servicerTenantName = i.tenantName;
        }
      });
      // form.currentTenantGuid = userinfo.tenantGuid;
      form.isSendFlowFlag = type == 1 ? 'Y' : 'N';//是否发起审批
      if (this.$route.query.toType == 3) {//重新提交
        form.bizApproveState = 'D';
      }
      if (this.formData.guid) {
        reqUrl = `/upstream/payment-plan-invoice-apply/update`;
      } else {
        reqUrl = `/upstream/payment-plan-invoice-apply/add`;
      }
      //附件处理
      form.otherFile = [];
      if (this.otherFile && this.otherFile.length > 0) {
        this.otherFile.forEach((i) => {
          let obj = {
            fileName: i.name,
            path: i.path,
          };
          form.otherFile.push(obj);
        });
      }
      this.fullscreenLoading = true;
      form.currentTenantGuid = localStorage.guid;
      //月份格式处理
      form.month = form.month ? form.month.replace('-', '') : form.month; 
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}${reqUrl}`, form)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: '提交成功',
              type: 'success',
            });
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    //获取流程Guid
    getFlowGuid() {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let req = {
        tenantGuid: localStorage.guid,
        flowType: this.flowType,
        staffGuid: userInfo.staffGuid,
      };
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              self.iframeSh = true;
              self.srcs =
                bpmnroute + '/iframeBpmn?camundaDeploymentId=' + res.data.data + '&token=' + localStorage.token;
              console.log(self.srcs);
            } else {
              self.$message.error('未获取到流程信息');
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //上传限制
    beforeAvatarUploadOther(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message({
          message: `上传文件大小不能超过 20MB!`,
          type: 'warning',
        });
      }
      return isLt2M;
    },
    uploadFileOther(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              path: res.data.data,
            };
            self.otherFile.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    // handleExceedOther(files) {
    //   this.$message.warning(`当前限制选择 1 个文件`);
    // },
    handleFileRemoveOther(file) {
      let self = this;
      self.otherFile.forEach(function (j, ind) {
        if (j.path == file.path) {
          self.otherFile.splice(ind, 1);
        }
      });
    },
    formatMoney(num) {
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      var parts = num.toString().split('.');

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // 将整数部分和小数部分拼接起来
      return parts.join('.');
    },
  },
};
</script>
<style scoped>
.sum-row{
  display: flex;
  flex-direction: column;
  align-items: center !important;
}
.sum-div{
  display: flex;
}
.contract-information-page {
  overflow: auto;
}
.contract-base-box {
  padding: 10px 16px;
  margin-top: 4px;
  background: #fff;
}
.contract-base-name {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 0 0 10px 0;
}
.contract-base-box .el-col-12,
.contract-base-box .el-col-24,
.contract-base-box .el-col-7,
.contract-base-box .el-col-6 {
  min-height: 37px;
  display: flex;
  /* align-items: center; */
  margin-bottom: 8px;
  padding-right: 20px;
  box-sizing: border-box;
}
.contract-base-title {
  flex-shrink: 0;
  width: 140px;
  line-height: 36px;
  text-align: right;
  font-size: 14px;
}
.contract-base-content {
  width: 314px;
  min-width: 314px;
  max-width: 314px;
  text-align: left;
  line-height: 36px;
}
/deep/.el-radio-group {
  padding-top: 5px !important;
}
/* 添加银行 */
.add-bank-box {
  color: #4fa1a4;
  margin-left: 15px;
  line-height: 36px;
}
.add-bank-box span {
  cursor: pointer;
}
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.invoice-category-btns{
  display: flex;
  align-items: center;
  color: #4fa1a4;
  cursor: pointer;
  flex-wrap: nowrap;
}
.invoice-category-btns .add{
  margin: 0 10px;
}
</style>
